export const getCrossConnectionLogsPerPage = state => {
    return state.activityLogs.crossConnectionLogsPerPage;
};
export const getKEXLogsPerPage = state => {
    return state.activityLogs.kexLogsPerPage;
};
export const getLocationLogsPerPage = state => {
    return state.activityLogs.locationLogsPerPage;
};
export const getLocationNetworkInterfacesLogsPerPage = state => {
    return state.activityLogs.locationNetworkInterfacesLogsPerPage;
};
export const getLocationsLogsPerPage = state => {
    return state.activityLogs.locationsLogsPerPage;
};
export const getNetworkInterfacesLogsPerPage = state => {
    return state.activityLogs.networkInterfacesLogsPerPage;
};
export const getUsersLogsPerPage = state => {
    return state.activityLogs.usersLogsPerPage;
};
